import React, { useEffect } from "react";
import styles from "../../styles/layout/sidebar.module.scss";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    List,
    ListItem,
    Typography,
} from "@mui/material";
import "react-perfect-scrollbar/dist/css/styles.css";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import { useAppSelector } from "../../hooks/useAppSelector";
import { setAdminSidebarOpen } from "../../redux-toolkit/slices/app.state.slice";

const SidebarAccordian = ({ isActive, menu, index }) => {
    const dispatch = useAppDispatch();
    let { pathname } = useLocation();

    const { adminSidbarOpen } = useAppSelector((s) => s.appStateSlice);

    useEffect(() => {
        if (isActive && index) {
            dispatch(setAdminSidebarOpen("panel" + index));
        }
    }, []);

    const handleChange = (panel) => (event, isExpanded) => {
        dispatch(setAdminSidebarOpen(isExpanded ? panel : false));
    };

    const navigate = useNavigate();
    return (
        <div>
            <Accordion
                expanded={adminSidbarOpen === "panel" + index}
                onChange={handleChange("panel" + index)}
            >
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    {menu.heading}
                </AccordionSummary>
                <AccordionDetails>
                    <List className={styles.submenuList}>
                        {menu?.subMenuItems?.map((subMenu, index) => {
                            let subMenuActive = false;
                            if (subMenu.link) {
                                if (subMenu.link === "/") {
                                    if (pathname === "/") {
                                        subMenuActive = true;
                                    }
                                } else {
                                    subMenuActive =
                                        pathname == subMenu.link ||
                                        pathname.includes(subMenu.link);
                                }
                            }
                            return (
                                <ListItem
                                    key={index}
                                    className={`${
                                        subMenuActive
                                            ? styles.submenu_active
                                            : ""
                                    } ${
                                        subMenu.heading === "Purchase Requests"
                                            ? styles.innerBadge
                                            : ""
                                    }`}
                                >
                                    <a
                                        href={subMenu?.link || "#"}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            if (subMenu.link) {
                                                navigate(subMenu.link);
                                            }
                                        }}
                                    >
                                        <figure>
                                            <img
                                                src={subMenu?.icon}
                                                alt="img"
                                                width={10}
                                                height={10}
                                            />
                                        </figure>
                                        <Typography variant="caption">
                                            {subMenu?.heading}
                                        </Typography>
                                    </a>
                                </ListItem>
                            );
                        })}
                    </List>
                </AccordionDetails>
            </Accordion>
        </div>
    );
};

export default SidebarAccordian;
